


<template> 
    <div :class="[{'vs-sidebar-group-open' : openItems}, {'vs-sidebar-group-active': open}, {'disabled-item pointer-events-none': group.isDisabled}]"
        class="vs-sidebar-group">
        <div @click="clickGroup" class="group-head w-full">
            <span class="data-report-item">
                <img width="26" src="@/assets/images/icons/actions/data-report.png" />
                <!-- <feather-icon :icon="group.icon || 'CircleIcon'" :svgClasses="{ 'w-3 h-3' : this.groupIndex % 1 != 0 }"
                    v-if="group.icon || (this.groupIndex > Math.floor(this.groupIndex))" /> -->
                <span v-show="!sidebarItemsMin" class="truncate select-none">{{ group.name }}<img class="ml-1 arrow-down" width="16" src="@/assets/images/icons/actions/angle-down.png" /></span>
                <vs-chip class="ml-auto mr-4" :color="group.tagColor" v-if="group.tag && !sidebarItemsMin">{{ group.tag
                }}</vs-chip>
            </span>
            <feather-icon icon="ChevronRightIcon" svg-classes="w-4 h-4"
                :class="[{'rotate90' : openItems}, 'feather-grp-header-arrow']" />
            <span class="vs-sidebar--tooltip">{{ group.name }}</span>
        </div>
        <ul ref="items" :style="styleItems" class="vs-sidebar-group-items">
            <template v-for="(groupItem, index) in group.submenu">
                <li v-if="((checkAllow && groupItem['name'] =='External Cases') || groupItem['name'] !='External Cases'   ) && groupItem.access.indexOf(currentUserRole) !=-1" :key="index" @click="activateSubMenu(group.submenu ,groupIndex,index )">
                    <vx-sidebar-group :group="groupItem" :groupIndex="Number(`${groupIndex}.${index}`)"
                        :open="isGroupActive(groupItem)" :openHover="openHover" v-if="groupItem.submenu" />
                    <vx-sidebar-item :ref="'subItem_'+groupIndex+'_'+index" v-model="groupItem.active" :index="groupIndex + '.' + index" :name="groupItem.name" :to="groupItem.url" :subItem="groupItem"
                        :icon="itemIcon(groupIndex + '.' + index)" :slug="groupItem.slug" icon-small
                        :target="groupItem.target" v-else>
                        <span class="truncate">{{ groupItem.name }} </span>
                        <vs-chip class="ml-auto" :color="groupItem.tagColor" v-if="groupItem.tag">{{ groupItem.tag }}
                        </vs-chip>
                    </vx-sidebar-item>
                </li>
            </template>  
        </ul>
    </div>
</template>

<script>
import VxSidebarItem from './VxSidebarItem.vue'
import * as _ from "lodash";

export default {
    name: 'vx-sidebar-group',
    props: {
        openHover: {
            default: false,
            type: Boolean
        },
        open: {
            default: false,
            type: Boolean
        },
        group: {
            type: Object
        },
        groupIndex: {
            type: Number,
        },
    },
    data: () => ({
        maxHeight: '0px',
        openItems: false,
        currentUserRole:0
    }),
    computed: {
        checkAllow(){
            let returnVal = false;
            if(this.checkProperty(this.$store.state,'user') && this.checkProperty(this.$store.state,'user','globalConfig')){
                if(this.checkProperty(this.$store.state['user'],'globalConfig','isAllowExternalCases')){
                    returnVal = true;
                }else{
                    returnVal = false;
                }
            }else{
                returnVal = false;
            }
            return returnVal;
           //return this.$store.state.user.globalConfig.isAllowExternalCases
        },
         checkUrl(){
            return group.url == this.$router.currentRoute.path

         },
        sidebarItemsMin() {
            return this.$store.state.sidebarItemsMin;
        },
        styleItems() {
            return {
                maxHeight: this.maxHeight
            }
        },
        itemIcon() {
            return (index) => {
                if (!((index.match(/\./g) || []).length > 1)) return "CircleIcon"
            }
        },
        isGroupActive() {
            let self =this;
            return (sidebarItem) => {

                const path = this.$route.fullPath;
                let open = false;
                let func = function(sidebarItem) {
                    if (sidebarItem.submenu) {
                        sidebarItem.submenu.forEach((item) => {
                            if (path == item.url || self.checkProperty(item ,'active') ==true) {
                                open = true
                            } else if (item.submenu) {
                                func(item)
                            }
                        })
                    }
                }

                func(sidebarItem)
                return open
            }
        },
    },
    watch: {
        // OPEN & CLOSES DROPDOWN ON ROUTE CHANGE
        '$route'() {
			if(this.sidebarItemsMin || this.open) return
            let scrollHeight = this.scrollHeight
            if (this.openItems && !this.open) {
                this.maxHeight = `${scrollHeight}px`
                setTimeout(() => {
                    this.maxHeight = `${0}px`
                }, 50)
            } else if (this.open) {
                this.maxHeight = `${scrollHeight}px`
                setTimeout(() => {
                    this.maxHeight = 'none'
                }, 300)
            }
        },
        maxHeight() {
            this.openItems = this.maxHeight != '0px'
        },
        // OPEN AND CLOSES DROPDOWN MENU ON SIDEBAR COLLAPSE AND DEFAULT VIEW
        '$store.state.sidebarItemsMin'(val) {
            			if( this.open) return

            let scrollHeight = this.$refs.items.scrollHeight
            if (!val && this.open) {
                this.maxHeight = `${scrollHeight}px`
                setTimeout(() => {
                    this.maxHeight = 'none'
                }, 300)
            } else {
                this.maxHeight = `${scrollHeight}px`
                setTimeout(() => {
                    this.maxHeight = '0px'
                }, 50)
            }
            if(val && this.open) {
				this.maxHeight = `${scrollHeight}px`
				setTimeout(() => {
					this.maxHeight = '0px'
				}, 250)
            }
        }
    },
    methods: {
        activateSubMenu(submenuList=[] ,groupIndex=-1 ,index =-1){
            let self =this;
            if(submenuList.length>0 && index>-1){
                _.forEach(submenuList , ( mn ,ind)=>{
    
                    try{
                        //subItem_
                        this.$refs['subItem_'+groupIndex+'_'+index].CheckIsActive(true);

                    }catch(err){
                       // alert(err);

                    }
                    mn['active'] =false;
                    if(ind== index){
                        mn['active'] =true;
                        
                        
                    }

                });

            }

        },
        clickGroup() {
            if (!this.openHover) {
                let thisScrollHeight = this.$refs.items.scrollHeight
                if (this.maxHeight == '0px') {
                    this.maxHeight = `${thisScrollHeight}px`
                    setTimeout(() => {
                        this.maxHeight = 'none'
                    }, 300)
                } else {
                    this.maxHeight = `${thisScrollHeight}px`
                    setTimeout(() => {
                        this.maxHeight = `${0}px`
                    }, 50)
                }

                this.$parent.$children.map((child) => {
                    if (child.isGroupActive) {

                        if (child !== this && (!child.open) && child.maxHeight != '0px') {
                            setTimeout(() => {
                                child.maxHeight = `${0}px`
                            }, 50)
                        }
                    }
                })
            }
        },
        mouseover() {
            if (this.openHover) {
                let scrollHeight = this.$refs.items.scrollHeight
                this.maxHeight = `${scrollHeight}px`
            }
        },
        mouseout() {
            var $self = this;
            if (this.openHover) {
                let scrollHeight = 0
               this.maxHeight = '0px'
            }
          

            	setTimeout(() => {
				  if( !$self.openHover) {
                 $self.maxHeight = '0px'
            }
				}, 250)
        }
    },
    components: {
        VxSidebarItem
    },
    mounted() {
        this.currentUserRole = parseInt(this.$store.state.userRole);
        this.openItems = this.open
        if (this.open) {
            this.maxHeight = 'none'
        }
    },
}
</script>

<style lang="scss">
@import "@/assets/scss/vuesax/components/vxSidebarGroup.scss"
</style>
